/**
 * Validate header title
 * - based on required flag
 * - and if submission name is not default or empty
 * @param args
 * @param {boolean} args.isRequired Is a submission name required by this template.
 * @param {submissionName} args.submissionName The submission name.
 * @returns {boolean}
 */
export function headerTitleIsInvalid({ isRequired, submissionName }): boolean {
  if (isRequired && (!submissionName || submissionName === 'Untitled Submission')) {
    return true
  }

  return false
}
